module.exports = fedopsLogger;